/*eslint-disable*/
import React from 'react';
// nodejs library that concatenates classes
import classNames from 'classnames';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

// core components
import Header from 'components/Header/Header.js';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Parallax from 'components/Parallax/Parallax.js';
import Footer from 'components/Footer/SerendipityFooter.js';

// sections for this page
import HeaderLinks from 'components/Header/HeaderLinks.js';
import SectionTeam from 'views/AboutUsPage/Sections/SectionTeam.js';

import aboutUsStyle from 'assets/jss/material-kit-pro-react/views/aboutUsStyle.js';
import SectionTestimonials from 'views/SectionsPage/Sections/SectionTestimonials.js';

const useStyles = makeStyles(aboutUsStyle);

export default function AboutUsPage() {
    React.useEffect(() => {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
    });
    const classes = useStyles();
    return (
        <div>
            <Header
                brand="Serendipity Bio"
                links={<HeaderLinks dropdownHoverColor="info" />}
                fixed
                color="transparent"
                changeColorOnScroll={{
                    height: 25,
                    color: 'dark'
                }}
            />
            <Parallax image={require('assets/img/bg9.jpg')} filter="dark" small>
                <div className={classes.container}>
                    <GridContainer justifyContent="center">
                        <GridItem
                            md={8}
                            sm={8}
                            className={classNames(
                                classes.mlAuto,
                                classes.mrAuto,
                                classes.textCenter
                            )}
                        >
                            <h1 className={classes.title}>About Us</h1>
                        </GridItem>
                    </GridContainer>
                </div>
            </Parallax>
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div className={classes.container}>
                    <SectionTestimonials />
                    <SectionTeam />
                </div>
            </div>
            <Footer darkFont />
        </div>
    );
}
